import React from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import {
  PageListBean,
  PhysicalInventoryAdjustmentSearchCriteria,
  RestPhysicalInventoryAdjustmentListRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmptyString } from "../gui_components/Util.js";
import { InventoryService } from "../services/InventoryService.js";
export class PhysicalInventoryAdjustmentLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let inventoryAdjustmentLookupCriteria =
      new PhysicalInventoryAdjustmentSearchCriteria();
    inventoryAdjustmentLookupCriteria.companyCode = this.companyCode;
    let resetCriteria = new PhysicalInventoryAdjustmentSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new PhysicalInventoryAdjustmentSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupCriteriaView = PhysicalInventoryAdjustmentLookupCriteraHandler(
      inventoryAdjustmentLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      inventoryAdjustmentLookupCriteria,
      lookupCriteriaView
    );
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition(" Created Date", "createdDate", 0, false); //1
    this.addColumnDefinition("Start Date", "fromDate", 0, false); //3
    this.addColumnDefinition("Stop Date", "toDate", 0, false); //3
    this.addColumnDefinition("Remarks", "remarks", 0, false); //3
  }
  loadInventoryAdjustmentList = (lookup_dialog, pageNumber, searchCriteria) => {
    let invAdj_criteria = new PhysicalInventoryAdjustmentSearchCriteria(); //To be fetched from CriteriaHandler
    invAdj_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      invAdj_criteria.physicalInventoryAdjustmentNumber =
        searchCriteria.physicalInventoryAdjustmentNumber;
      invAdj_criteria.createdDate = searchCriteria.createdDate;
      // invAdj_criteria.adjustmentCode = searchCriteria.adjustmentCode;
      // invAdj_criteria.adjustmentReason = searchCriteria.adjustmentReason;
      // invAdj_criteria.wareHouseCode = searchCriteria.wareHouseCode;
      // invAdj_criteria.fabricStyleCode = searchCriteria.fabricStyleCode;
      // invAdj_criteria.fabricStyleColorCode =
      //   searchCriteria.fabricStyleColorCode;
    }
    let invAdj_pageList = new PageListBean();
    invAdj_pageList.pageSize = 50; //TODO --> Fetch from Config
    invAdj_pageList.pageNumber = pageNumber;
    invAdj_pageList.currentPage = pageNumber;
    let invAdj_requestInput = new RestPhysicalInventoryAdjustmentListRequest();
    invAdj_requestInput.pageInput = invAdj_pageList;
    invAdj_requestInput.searchCriteria = invAdj_criteria;
    InventoryService.getPhysicalInventoryAdjustmentPageList(
      invAdj_requestInput,
      (response) =>
        this.loadInventoryAdjustmentListResponse(response, lookup_dialog),
      this.loadInventoryAdjustmentListError
    );
  };
  loadInventoryAdjustmentListResponse = (response, lookup_dialog) => {
    let invAdjList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.physicalInventoryAdjustmentPageList != null &&
      response.data.physicalInventoryAdjustmentPageList
        .physicalInventoryAdjustments !== null
    ) {
      invAdjList =
        response.data.physicalInventoryAdjustmentPageList
          .physicalInventoryAdjustments;
      totalCount = response.data.physicalInventoryAdjustmentPageList.totalCount;
      currentPageNumber =
        response.data.physicalInventoryAdjustmentPageList.currentPage;
      pageSize = response.data.physicalInventoryAdjustmentPageList.pageSize;
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = invAdjList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadInventoryAdjustmentListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.physicalInventoryAdjustmentNumber)) {
      if (!isEmptyString(filterText)) {
        search.physicalInventoryAdjustmentNumber = filterText;
        this.searchCriteria = new PhysicalInventoryAdjustmentSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadInventoryAdjustmentList(lookup_dialog, pageNumber, search);
    }
  }
}
const PhysicalInventoryAdjustmentLookupCriteraHandler = (
  companyCode,
  inventoryAdjustmentLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new PhysicalInventoryAdjustmentSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      this.setState({
        searchCriteria: new PhysicalInventoryAdjustmentSearchCriteria(),
      });
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container>
            <Row>
              <Col sm={5}>
                <FormLabel>PhysicalInventoryAdjustment#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="physicalInventoryAdjustmentNumber"
                  name="physicalInventoryAdjustmentNumber"
                  onChange={this.onChange}
                  value={searchCriteria.physicalInventoryAdjustmentNumber}
                />
              </Col>
            </Row>
            {/* <Row>
              <Col sm={5}>
                <FormLabel>Adjustment Code Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="adjustmentCodeContains"
                  name="adjustmentCodeContains"
                  onChange={this.onChange}
                  value={searchCriteria.adjustmentCodeContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Adjustment Code</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="adjustmentCode"
                  name="adjustmentCode"
                  onChange={this.onChange}
                  value={searchCriteria.adjustmentCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>AdjustmentReason</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="adjustmentReason"
                  name="adjustmentReason"
                  onChange={this.onChange}
                  value={searchCriteria.adjustmentReason}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>WareHouseCode</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="wareHouseCode"
                  name="wareHouseCode"
                  onChange={this.onChange}
                  value={searchCriteria.wareHouseCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>FabricStyleCode</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="fabricStyleCode"
                  name="fabricStyleCode"
                  onChange={this.onChange}
                  value={searchCriteria.fabricStyleCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>FabricStyleColorCode</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="fabricStyleColorCode"
                  name="fabricStyleColorCode"
                  onChange={this.onChange}
                  value={searchCriteria.fabricStyleColorCode}
                />
              </Col>
            </Row> */}
            <Row className="popup_criteria_button_align-lookup">
              <Button
                ref={this.focusRef}
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
